import React from "react";
import { BaseForm, Input, VALIDATION_TYPES } from "../../../../components/Form";
import { cloneMutables } from "../../../../lib/stateManagement/";
import { getMessage } from "../../../../lib/translator";
import { getSession } from "../../../../lib/auth";
import "./style.css";
import { get } from "../../../../lib/storage";
import LayoutManager from "../../../../components/LayoutManager";
import { getSlugFromText } from "../../../../components/normalizeSlug";

export default class WebsitePageForm extends BaseForm {
  constructor(props) {
    super(props);
    this.domain = getSession().organization.domain;
    this.state.showDialog = false;
    this.direction = get("dataLang") === "ar" ? "rtl" : "ltr";
    let layouts =
      this.state.values?.layouts && this.state.values?.layouts?.filter(Boolean);
    if (!layouts) {
      this.state.values = {
        layouts: [],
      };
    }
    this.state.showLayoutPopup = false;
    this.state.showDialog = false;
    this.state.currentComponent = "Banners";
    this.pages = ["staticPage"];
    this.data = [];
    this.currentLayout = {};
    this.selectOptionsData = {
      categories: [],
      tags: [],
      brands: [],
    };
  }

  onSubmit = (values) => {
    this.setState(
      (prevState) => Object.assign({}, prevState, { values }),
      this._submitHandler
    );
  };

  updateLayouts = (updatedLayouts) => {
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        layouts: updatedLayouts,
      },
    }));
  };
  render() {
    const { CancelButton } = this.buttons;
    const { Form } = this.components;
    return (
      <div className="website-page-edit">
        <Form className="website-page-form">
          <Input
            className="title-input"
            label={getMessage("websitePage.form.title.heading")}
            placeholder={getMessage("websitePage.form.title.placeholder")}
            name="title"
            type="text"
            required
            {...this.generateStateMappers({
              stateKeys: ["title"],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
            onBlur={() => {
              if (!this.getState(["url"]) && this.direction !== "rtl") {
                this.updateState(
                  ["url"],
                  getSlugFromText(this.getState(["title"]))
                );
              }
            }}
            validationStrings={{
              valueMissing: getMessage(
                "websitePage.form.title.requiredMessage"
              ),
            }}
            dir={this.direction}
          />
          <Input
            className="url-input"
            label={getMessage("websitePage.form.url.heading")}
            placeholder={getMessage("websitePage.form.url.placeholder")}
            name="url"
            type="text"
            required
            prefix={`${this.domain}/pages/`}
            {...this.generateStateMappers({
              stateKeys: ["url"],
              validationType: VALIDATION_TYPES.ONSUBMIT,
              loseEmphasisOnFill: true,
            })}
            validationStrings={{
              valueMissing: getMessage("input.requiredMessage"),
            }}
          />
          <LayoutManager
            layouts={this.state?.values?.layouts}
            page={this.pages}
            updateLayoutsData={this.updateLayouts}
          />
          <div className="form-buttons">
            <button
              type="button"
              className="primary button"
              onClick={(e) => {
                e.preventDefault();
                let updates = {
                  isDraft: false,
                };
                if (!this.state.values.publishTime) {
                  let now = new Date();
                  updates.publishTime = `${now.getFullYear()}-${String(
                    now.getMonth() + 1
                  ).padStart(2, "0")}-${String(now.getDate()).padStart(
                    2,
                    "0"
                  )} ${now.toTimeString().split(" ")[0]}`;
                }
                this.onSubmit(
                  Object.assign({}, cloneMutables(this.state.values), updates)
                );
              }}
            >
              {getMessage("marketing.blog.form.submitText")}
            </button>
            <CancelButton>
              {getMessage("websitePage.form.cancelText")}
            </CancelButton>
          </div>
        </Form>
      </div>
    );
  }
}
